module.exports = __webpack_public_path__ + "img/migrants-mortality.99c10479.png";